<style scoped>
    .item{
        display: inline-block;
        vertical-align: middle;
        margin: 2px;
    }
</style>
<template>
    <div class="item">
        <ButtonGroup size="small" v-if="fin_team.id">
            <Button>{{fin_team.name}}</Button>
            <Button @click="edit(fin_team)" icon="md-create"></Button>
        </ButtonGroup>
        <Button size="small" type="primary" icon="md-add" @click="edit(new_fin_team)" v-else>添加</Button>
        <Modal
            transfer
            v-model="config.modal"
            title="添加 / 修改"
            ok-text="保存"
            :loading="config.loading"
            @on-ok="editOk">
            <Form ref="periodForm" :model="edit_team" :label-width="60">
                <Form-item label="名称">
                    <i-input v-model="edit_team.name"></i-input>
                </Form-item>
                <Form-item label="所属区域">
                    <Select transfer v-model="edit_team.group_id">
                        <Option :value="0">无</Option>
                        <Option :value="group.id" v-for="group in fin_team_groups" :key="group.id">{{group.name}}</Option>
                    </Select>
                </Form-item>
                <Form-item label="成立日期">
                    <DatePicker type="date" transfer @on-change="dateChange" v-model="edit_team.set_up_date"></DatePicker>
                </Form-item>
                <Form-item label="排序">
                    <InputNumber v-model="edit_team.sort_order"></InputNumber>
                </Form-item>
                <Form-item label="虚拟组">
                    <Checkbox v-model="edit_team.is_virtual"></Checkbox>
                </Form-item>
            </Form>
        </Modal>
    </div>
</template>
<script>
    export default {
        props: {
            fin_team: {
                type: Object
            },
            fin_team_groups: {
                type: Array
            }
        },
        data(){
            return {
                config: {
                    modal: false,
                    loading: true
                },
                edit_team: {},
                new_fin_team: {
                    name: '',
                    group_id: 0,
                    set_up_date: '',
                    sort_order: 0,
                    is_virtual: false
                }
            }
        },
        computed: {
            //
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            edit(team){
                this.edit_team = Util.clone(team);
                this.config.modal = true;
            },
            dateChange(date){
                this.edit_team.set_up_date = date;
            },
            editOk(){
                Util.ajax.post(Util.api.fin_team_update, this.edit_team).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    console.log(res);
                    if(res.code === 1){
                        this.config.modal = false;
                        this.$emit('update', res.data.fin_team);
                    }else{
                        this.resetLoading();
                        this.$Modal.warning({title: '错误', content: res.msg});
                    }
                }).catch((e)=>{
                    this.resetLoading();
                    this.$Modal.warning({title: '错误', content: e.message});
                });
            },
            resetLoading(){
                this.config.loading = false;
                setTimeout(()=>{
                    this.config.loading = true;
                }, 500);
            }
        }
    }
</script>
